import assert from 'owa-assert/lib/assert';
import type { MailboxInfo } from 'owa-client-types';

type FallbackFunction = () => MailboxInfo;

let fallbackMailboxFunction: FallbackFunction | undefined = undefined;

export function setFallbackMailboxFunction(fallback: FallbackFunction): void {
    fallbackMailboxFunction = fallback;
}

export function callFallbackMailboxFunction(): MailboxInfo {
    assert(!!fallbackMailboxFunction, 'Call setFallbackMailboxFunction to set the function');
    return fallbackMailboxFunction();
}
